<template>
    <div id="cameras_page">
      <div style="display: flex; justify-content: space-between">
        <h1>{{ $i18n.t('pages.devices.title') }}</h1>
        <v-btn
          v-if="loadingOverlay.reload_required"
          class="white--text mr-1 ml-1"
          color="#DBEAF1"
          elevation="0"
          height="42"
          @click="send_system_reload_message"
        >
          <span class="main_color button-font">{{ $i18n.t('general.system_reboot') }}</span>
        </v-btn>
      </div>

      <v-tabs v-model="current_tab" style="margin-top: 15px;" background-color="transparent">
        <v-tab><span class="tab-font">{{ $i18n.t('pages.devices.cameras.cameras_settings') }}</span></v-tab>
        <v-tab><span class="tab-font">{{ $i18n.t('pages.devices.relays.relays_settings') }}</span></v-tab>

        <v-tab-item key="cameras" class="rounded_8px">
          <cameras-setup
            :checkpoints="checkpoints"
            :gates="gates"
            :cams_data="cams_data"
            :cams_table_loading="cams_table_loading"
            @changes_applied="set_reload_required"
          />
        </v-tab-item>

        <v-tab-item key="relays" class="rounded_8px">
          <relay-setup
            :checkpoints="checkpoints"
            :gates="gates"
            :relays_data="relays_data"
            :viports_data="viports_data"
            style="margin-top: 10px"
            @changes_applied="set_reload_required"
          />
        </v-tab-item>
      </v-tabs>
      <div class="plus-button-component-positioning">
        <v-btn v-if="current_tab === 0"
          class="white--text rounded-plus-button"
          elevation="0"
          fab
          width="72px"
          height="72px"
          @click="add_camera"
        >
          <v-icon size="72px">$icon_rounded_plus</v-icon>
        </v-btn>
      </div>
    </div>
</template>

<script>
import CamerasSetup from "../components/CamerasSetup";
import RelaySetup from "@/components/RelaySetup";
import {i18n} from "@/i18n";
import {EventBus} from "@/bus";
import {common_funcs} from "@/mixins/common";
import {mapGetters} from "vuex";

export default {
  name: "DevicesPage",
  components: {
    RelaySetup,
      CamerasSetup,
  },
  mixins: [common_funcs],
  data: function () {
    this.fetch_cameras_data()
    this.fetch_relays_data()
    return {
      current_tab: null,
      cams_table_loading: true,
      relays_table_loading: true,
      checkpoints: [],
      gates: [],
      cams_data: [],
      relays_data: [],
      viports_data: []
    }
  },
  methods: {
    fetch_cameras_data: function () {
      let t = this
      this.$http({url: this.$http_hostname + '/cameras_settings/all', method: 'GET'})
      .then(resp => {
        t.cams_data = resp.data.cams
        t.checkpoints = resp.data.checkpoints
        t.gates = resp.data.gates
        t.cams_table_loading = false
      })
      .catch(() => {
        t.setSnackbar({
          text: i18n.t('notifications.error_during_data_loading'),
        })
        t.cams_table_loading = false
        t.relays_table_loading = false
      })
    },

    add_camera: function () {
      EventBus.$emit('cameras_event', {event_name: 'add_camera'})
    },

    fetch_relays_data: function () {
      let t = this
      this.$http({url: this.$http_hostname + '/viport_relays_settings/all', method: 'GET'})
      .then(resp => {
        t.viports_data = resp.data.viports
        t.relays_data = resp.data.relays
        t.relays_table_loading = false
      })
      .catch(() => {
        t.setSnackbar({
          text: i18n.t('notifications.error_during_data_loading'),
        })
        t.cams_table_loading = false
        t.relays_table_loading = false
      })
    },
    set_reload_required: function () {
      this.$store.state.loading_overlay.reload_required = true
    },
  },
  computed: {
    ...mapGetters(['loadingOverlay'])
  },
}
</script>

<style lang="scss">

</style>